package ru.chm.gradereport.ui.screens.login

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import kotlinx.coroutines.launch
import ru.chm.gradereport.data.ApiException
import ru.chm.gradereport.data.GradeApi
import ru.chm.gradereport.model.LoginResponse
import ru.chm.gradereport.ui.components.AppCard
import ru.chm.gradereport.ui.components.ErrorBanner
import ru.chm.gradereport.ui.components.SectionTitle
import ru.chm.gradereport.ui.components.SelectableText
import ru.chm.gradereport.ui.components.ThemeModeDropdown
import ru.chm.gradereport.ui.components.adaptiveContentPadding
import ru.chm.gradereport.ui.theme.GradeTheme
import ru.chm.gradereport.ui.theme.GreenAccent
import ru.chm.gradereport.ui.theme.LocalThemeController

@Composable
fun LoginScreen(
    api: GradeApi,
    onLoggedIn: (LoginResponse) -> Unit,
) {
    var loading by remember { mutableStateOf(false) }
    var error by remember { mutableStateOf<String?>(null) }
    val scope = rememberCoroutineScope()
    val colors = GradeTheme.colors
    val theme = LocalThemeController.current

    BoxWithConstraints(
        modifier = Modifier.fillMaxSize(),
    ) {
        val pad = adaptiveContentPadding(maxWidth)
        Box(
            modifier = Modifier
                .fillMaxSize()
                .padding(horizontal = pad, vertical = 12.dp),
        ) {
        if (theme != null) {
            ThemeModeDropdown(
                mode = theme.mode,
                onModeChange = theme.onModeChange,
                modifier = Modifier.align(Alignment.TopEnd),
            )
        }

        Column(
            modifier = Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            AppCard(modifier = Modifier.widthIn(max = 420.dp).fillMaxWidth()) {
                SelectableText(
                    text = "ЦХМ",
                    color = GreenAccent,
                    fontSize = 28.sp,
                    fontWeight = FontWeight.Bold,
                )
                SectionTitle("Учебная Ведомость", modifier = Modifier.padding(top = 12.dp))
                ErrorBanner(error) { error = null }

                val formStyle = remember(colors) {
                    NativeLoginFormStyle(
                        background = colors.card.toHexColor(),
                        border = colors.border.toHexColor(),
                        text = colors.textPrimary.toHexColor(),
                        muted = colors.textMuted.toHexColor(),
                        accent = GreenAccent.toHexColor(),
                    )
                }
                NativeLoginForm(
                    style = formStyle,
                    loading = loading,
                    submitText = if (loading) "Вход..." else "Войти",
                    onSubmit = { user, pass ->
                        scope.launch {
                            loading = true
                            error = null
                            try {
                                val result = api.login(user, pass)
                                api.setToken(result.token)
                                onLoggedIn(result)
                            } catch (e: ApiException) {
                                error = e.message
                            } catch (e: Exception) {
                                val details = e.message ?: e::class.simpleName ?: "unknown"
                                error = "Не удалось войти ($details). Убедитесь, что сервер запущен: ./gradlew :server:run (http://localhost:8085)"
                            } finally {
                                loading = false
                            }
                        }
                    },
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(top = 16.dp)
                        .height(NativeLoginFormHeight),
                )
            }
        }
        }
    }
}
